import Vue from "vue";
import VueRouter from "vue-router";
import { getTenantById } from "@/api/template";

Vue.use(VueRouter);

// 检测是否为移动设备
function isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}

// 根据type获取对应的重定向路径
function getRedirectPath(type) {
  switch (type) {
    case 1:
      return "/first-home";
    case 2:
      return "/second-home";
    case 3:
      return "/third-home";
    case 4:
      return "/fourth-home";
    case 5:
      return "/fifth-home";
    case 6:
      return "/sixth-home";
    case 7:
      return "/seventh-home";
    case 8:
      // 第八套模板：桌面版和移动版都使用相同的type值，通过设备检测区分
      return isMobile() ? "/eighthMobile-home" : "/eighth-home";
    case 9:
      return "/ninth-home";
    case 10:
      // 第十套模板：有专门的移动版本
      return isMobile() ? "/tenthMobile-home" : "/tenth-home";
    case 11:
      return "/eleventh-home";
    case 12:
      return "/second2-home";
    case 13:
      // 货币模板：专门用于货币相关的展示
      return "/currency-home";
    default:
      return "/first-home"; // 默认重定向到第一套模板
  }
}

const routes = [
  // 第一套模板路由
  {
    path: "/first-home",
    name: "first-home",
    component: () => import("@/pages/template/first/first.vue"),
    meta: { index: 1 },
    redirect: "/template-first",
    children: [
      {
        path: "/template-first",
        name: "template-first",
        component: () => import("@/pages/template/first/index.vue"),
        meta: { index: 4 },
      },
      {
        path: "/first-list/:name/:id/:type",
        name: "first-list",
        props: true,
        component: () => import("@/pages/template/first/list.vue"),
        meta: { index: 4 },
      },
      {
        path: "/first-transfer/:name/:id/:type",
        name: "first-transfer",
        props: true,
        component: () => import("@/pages/template/first/transfer.vue"),
        meta: { index: 4 },
      },
      {
        path: "/first-details",
        name: "first-details",
        props: true,
        component: () => import("@/pages/template/first/details.vue"),
        meta: { index: 5 },
      },
    ],
  },

  // 第二套模板路由
  {
    path: "/second-home",
    name: "second-home",
    component: () => import("@/pages/template/second/second.vue"),
    meta: { index: 5 },
    redirect: "/template-second",
    children: [
      {
        path: "/template-second",
        name: "template-second",
        component: () => import("@/pages/template/second/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/second-list/:name/:id/:type/:index",
        name: "second-list",
        props: true,
        component: () => import("@/pages/template/second/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/second-transfer/:name/:id/:type/:index",
        name: "second-transfer",
        props: true,
        component: () => import("@/pages/template/second/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/second-details",
        name: "second-details",
        props: true,
        component: () => import("@/pages/template/second/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第二套模板变体路由
  {
    path: "/second2-home",
    name: "second2-home",
    component: () => import("@/pages/template/second2/second.vue"),
    meta: { index: 4 },
    redirect: "/template-second2",
    children: [
      {
        path: "/template-second2",
        name: "template-second2",
        component: () => import("@/pages/template/second2/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/second2-list/:name/:id/:type/:index",
        name: "second2-list",
        props: true,
        component: () => import("@/pages/template/second2/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/second2-transfer/:name/:id/:type/:index",
        name: "second2-transfer",
        props: true,
        component: () => import("@/pages/template/second2/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/second2-details",
        name: "second2-details",
        props: true,
        component: () => import("@/pages/template/second2/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第三套模板路由
  {
    path: "/third-home",
    name: "third-home",
    component: () => import("@/pages/template/third/third.vue"),
    meta: { index: 9 },
    redirect: "/template-third",
    children: [
      {
        path: "/template-third",
        name: "template-third",
        component: () => import("@/pages/template/third/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/third-list/:name/:id/:type/:index",
        name: "third-list",
        props: true,
        component: () => import("@/pages/template/third/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/third-transfer/:name/:id/:type/:index",
        name: "third-transfer",
        props: true,
        component: () => import("@/pages/template/third/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/third-details",
        name: "third-details",
        props: true,
        component: () => import("@/pages/template/third/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第四套模板路由
  {
    path: "/fourth-home",
    name: "fourth-home",
    component: () => import("@/pages/template/fourth/fourth.vue"),
    meta: { index: 13 },
    redirect: "/template-fourth",
    children: [
      {
        path: "/template-fourth",
        name: "template-fourth",
        component: () => import("@/pages/template/fourth/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/fourth-list/:name/:id/:type",
        name: "fourth-list",
        props: true,
        component: () => import("@/pages/template/fourth/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/fourth-transfer/:name/:id/:type",
        name: "fourth-transfer",
        props: true,
        component: () => import("@/pages/template/fourth/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/fourth-details",
        name: "fourth-details",
        props: true,
        component: () => import("@/pages/template/fourth/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第五套模板路由
  {
    path: "/fifth-home",
    name: "fifth-home",
    component: () => import("@/pages/template/fifth/fifth.vue"),
    meta: { index: 17 },
    redirect: "/template-fifth",
    children: [
      {
        path: "/template-fifth",
        name: "template-fifth",
        component: () => import("@/pages/template/fifth/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/fifth-list/:name/:id/:type/:index",
        name: "fifth-list",
        props: true,
        component: () => import("@/pages/template/fifth/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/fifth-transfer/:name/:id/:type/:index",
        name: "fifth-transfer",
        props: true,
        component: () => import("@/pages/template/fifth/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/fifth-details",
        name: "fifth-details",
        props: true,
        component: () => import("@/pages/template/fifth/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第六套模板路由
  {
    path: "/sixth-home",
    name: "sixth-home",
    component: () => import("@/pages/template/sixth/sixth.vue"),
    meta: { index: 21 },
    redirect: "/template-sixth",
    children: [
      {
        path: "/template-sixth",
        name: "template-sixth",
        component: () => import("@/pages/template/sixth/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/sixth-list/:name/:id/:type",
        name: "sixth-list",
        props: true,
        component: () => import("@/pages/template/sixth/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/sixth-transfer/:name/:id/:type",
        name: "sixth-transfer",
        props: true,
        component: () => import("@/pages/template/sixth/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/sixth-details",
        name: "sixth-details",
        props: true,
        component: () => import("@/pages/template/sixth/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第七套模板路由
  {
    path: "/seventh-home",
    name: "seventh-home",
    component: () => import("@/pages/template/seventh/seventh.vue"),
    meta: { index: 25 },
    redirect: "/template-seventh",
    children: [
      {
        path: "/template-seventh",
        name: "template-seventh",
        component: () => import("@/pages/template/seventh/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/seventh-list/:name/:id/:type",
        name: "seventh-list",
        props: true,
        component: () => import("@/pages/template/seventh/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/seventh-transfer/:name/:id/:type",
        name: "seventh-transfer",
        props: true,
        component: () => import("@/pages/template/seventh/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/seventh-details",
        name: "seventh-details",
        props: true,
        component: () => import("@/pages/template/seventh/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第八套模板路由
  {
    path: "/eighth-home",
    name: "eighth-home",
    component: () => import("@/pages/template/eighth/eighth.vue"),
    meta: { index: 29 },
    redirect: "/template-eighth",
    children: [
      {
        path: "/template-eighth",
        name: "template-eighth",
        component: () => import("@/pages/template/eighth/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/eighth-list/:name/:id/:type",
        name: "eighth-list",
        props: true,
        component: () => import("@/pages/template/eighth/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/eighth-transfer/:name/:id/:type",
        name: "eighth-transfer",
        props: true,
        component: () => import("@/pages/template/eighth/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/eighth-details",
        name: "eighth-details",
        props: true,
        component: () => import("@/pages/template/eighth/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第八套模板移动版路由
  {
    path: "/eighthMobile-home",
    name: "eighthMobile-home",
    component: () => import("@/pages/template/eighthMobile/eighthMobile.vue"),
    meta: { index: 4 },
    redirect: "/template-eighthMobile",
    children: [
      {
        path: "/template-eighthMobile",
        name: "template-eighthMobile",
        component: () => import("@/pages/template/eighthMobile/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/eighthMobile-list/:name/:id/:type",
        name: "eighthMobile-list",
        props: true,
        component: () => import("@/pages/template/eighthMobile/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/eighthMobile-transfer/:name/:id/:type",
        name: "eighthMobile-transfer",
        props: true,
        component: () => import("@/pages/template/eighthMobile/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/eighthMobile-details",
        name: "eighthMobile-details",
        props: true,
        component: () => import("@/pages/template/eighthMobile/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第九套模板路由
  {
    path: "/ninth-home",
    name: "ninth-home",
    component: () => import("@/pages/template/ninth/ninth.vue"),
    meta: { index: 33 },
    redirect: "/template-ninth",
    children: [
      {
        path: "/template-ninth",
        name: "template-ninth",
        component: () => import("@/pages/template/ninth/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/ninth-list/:name/:id/:type",
        name: "ninth-list",
        props: true,
        component: () => import("@/pages/template/ninth/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/ninth-transfer/:name/:id/:type",
        name: "ninth-transfer",
        props: true,
        component: () => import("@/pages/template/ninth/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/ninth-details",
        name: "ninth-details",
        props: true,
        component: () => import("@/pages/template/ninth/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第十套模板路由
  {
    path: "/tenth-home",
    name: "tenth-home",
    component: () => import("@/pages/template/tenth/tenth.vue"),
    meta: { index: 37 },
    redirect: "/template-tenth",
    children: [
      {
        path: "/template-tenth",
        name: "template-tenth",
        component: () => import("@/pages/template/tenth/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/tenth-list/:name/:id/:type",
        name: "tenth-list",
        props: true,
        component: () => import("@/pages/template/tenth/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/tenth-transfer/:name/:id/:type",
        name: "tenth-transfer",
        props: true,
        component: () => import("@/pages/template/tenth/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/tenth-details",
        name: "tenth-details",
        props: true,
        component: () => import("@/pages/template/tenth/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第十套模板移动版路由
  {
    path: "/tenthMobile-home",
    name: "tenthMobile-home",
    component: () => import("@/pages/template/tenthMobile/tenthMobile.vue"),
    meta: { index: 4 },
    redirect: "/template-tenthMobile",
    children: [
      {
        path: "/template-tenthMobile",
        name: "template-tenthMobile",
        component: () => import("@/pages/template/tenthMobile/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/tenthMobile-list/:name/:id/:type",
        name: "tenthMobile-list",
        props: true,
        component: () => import("@/pages/template/tenthMobile/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/tenthMobile-transfer/:name/:id/:type",
        name: "tenthMobile-transfer",
        props: true,
        component: () => import("@/pages/template/tenthMobile/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/tenthMobile-details",
        name: "tenthMobile-details",
        props: true,
        component: () => import("@/pages/template/tenthMobile/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 第十一套模板路由
  {
    path: "/eleventh-home",
    name: "eleventh-home",
    component: () => import("@/pages/template/eleventh/eleventh.vue"),
    meta: { index: 41 },
    redirect: "/template-eleventh",
    children: [
      {
        path: "/template-eleventh",
        name: "template-eleventh",
        component: () => import("@/pages/template/eleventh/index.vue"),
        meta: { index: 5 },
      },
      {
        path: "/eleventh-list/:name/:id/:type",
        name: "eleventh-list",
        props: true,
        component: () => import("@/pages/template/eleventh/list.vue"),
        meta: { index: 5 },
      },
      {
        path: "/eleventh-transfer/:name/:id/:type",
        name: "eleventh-transfer",
        props: true,
        component: () => import("@/pages/template/eleventh/transfer.vue"),
        meta: { index: 5 },
      },
      {
        path: "/eleventh-details",
        name: "eleventh-details",
        props: true,
        component: () => import("@/pages/template/eleventh/details.vue"),
        meta: { index: 6 },
      },
    ],
  },

  // 货币模板路由
  {
    path: "/currency-home",
    name: "currency-home",
    component: () => import("@/pages/template/currencyTemplate/currency.vue"),
    meta: { index: 4 },
    redirect: "/currency",
    children: [
      {
        path: "/currency",
        name: "currency",
        component: () => import("@/pages/template/currencyTemplate/index.vue"),
        meta: { index: 5 },
      },
    ],
  },

  // 默认路由 - 根据接口返回的type动态重定向
  // {
  //   path: '/',
  //   redirect: '/first-home'
  // }

  // 默认路由 - 根据接口返回的type动态重定向
  {
    path: "/",
    beforeEnter: (to, from, next) => {
      // 调用getTenantById接口获取租户信息
      getTenantById(document.domain)
        .then((res) => {
          // getTenantById("www.gdhandball.cn")
          // .then((res) => {
          if (res.code === 200 && res.data && res.data.type) {
            const redirectPath = getRedirectPath(res.data.type);
            console.log(redirectPath, "redirectPath");
            next(redirectPath);
          } else {
            // 如果接口调用失败或没有type，默认重定向到第一套模板
            next("/first-home");
          }
        })
        .catch(() => {
          // 接口调用异常时，默认重定向到第一套模板
          next("/first-home");
        });
    },
  },
];

// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((error) => error);
};

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
